<template>
  <fn-tooltip
    :open="open"
    :placement="placement"
    @auto-hide="open = false"
  >
    <template #default>
      <fn-button
        ref="infoButton"
        class="open-button"
        plain
        :aria-label="ariaLabelOpenButton"
        aria-haspopup="dialog"
        @click.prevent="toggle"
        @keydown.enter.prevent="toggle"
        @keydown.space.prevent="toggle"
      >
        <fn-icon
          :icon="getIconType"
          :color="color"
          :token-color="tokenColor"
          :size="size"
        />
      </fn-button>
    </template>
    <template #popover>
      <div
        class="info-i-content"
        :class="{
          'info-i-content--wide': wide,
        }"
        role="dialog"
      >
        <slot />
      </div>

      <fn-button
        class="close-button"
        plain
        :aria-label="ariaLabelCloseButton"
        @click.prevent="close"
        @keydown.enter="close"
        @keydown.space.prevent="close"
      >
        <fn-icon
          icon="cross"
          color="grey"
          size="xxs"
        />
      </fn-button>
    </template>
  </fn-tooltip>
</template>

<script>
export default defineComponent({
  props: {
    wide: {
      type: Boolean,
    },
    placement: {
      type: String,
      default: 'bottom',
    },
    light: {
      type: Boolean,
      default: false,
    },
    /* Accepts token color name from the _tokens.scss file.
     * TODO: Remove support for color prop usage once palette() usage is dropped.
     */
    tokenColor: {
      type: String,
      default: '',
    },
    color: {
      type: String,
      default: 'grey-light',
    },
    size: {
      type: String,
      default: 'xs',
    },
    ariaLabelOpenButton: {
      type: String,
      default: '',
    },
    ariaLabelCloseButton: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      open: false,
    };
  },
  computed: {
    getIconType() {
      return this.light ? 'circle-i-light' : 'circle-i';
    },
  },
  methods: {
    close() {
      this.open = false;
      this.$nextTick(() => {
        this.$refs?.infoButton?.$el.focus({ focusVisible: true });
      });
    },
    toggle() {
      this.open = !this.open;
    },
  },
});
</script>

<style lang="scss" scoped>
.info-i-content {
  padding: $pad 42px $pad $pad;
  min-width: 180px;
  max-width: 300px;
  font-size: map-get($font-sizes, 'm');

  &.info-i-content--wide {
    max-width: 420px;
  }
}

.close-button {
  position: absolute;
  right: 16px;
  top: 19px;
  min-height: auto;
  min-width: auto;

  &:focus-visible {
    @include focus-outline-default;
    outline-offset: 0px;
    padding: 0 math.div($pad, 4);
    width: 16px;
  }
}

.open-button {
  min-height: unset;
  min-width: auto;

  :deep(.icon) {
    line-height: 100%;
  }

  &:focus-visible {
    @include focus-outline-default;
    outline-offset: 0px;
    padding: 0;
    line-height: 16px;
    min-height: 16px;
    width: 16px;
  }
}

a {
  text-decoration: none;
}

.v-popper {
  width: 16px;
}

.v-popover {
  line-height: 100%;
}
</style>
